var cilResizeWidth = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M366.156,392H328V320H184v72H145.373L9.607,256.235,145.845,120H184v72H328V120h38.627L502.393,255.765ZM54.863,256.235,152,353.373V288H360v64.9l97.137-97.137L360,158.627V224H152V159.1Z' class='ci-primary'/>"];

export { cilResizeWidth };

